module.exports = __webpack_public_path__ + "media/use_cases/slider-portrait-2-ca61d603.png";